import React from "react";

export const FacilityContext = React.createContext("");
